// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-web-members-operations-request-schema',
  type: 'object',
  required: ['organisationId'],
  properties: {
    organisationId: {
      type: 'string',
      format: 'uuid',
    },
    year: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
